import React from 'react';
import { Stack, Text } from '@moda/om';

export const AmazonPaymentMethodPreview: React.FC = ({ children }) => (
  <Stack space={0}>
    <Stack space={1} direction="horizontal" alignItems="center">
      <img src="/amazon_payments.png" alt="Amazon Payments" />
      <Text treatment="eyebrow">Payment Method</Text>
    </Stack>
    <Stack space={0} direction="horizontal" justifyContent="space-between">
      <Text>Your selected Amazon Payment Method</Text>
      {children}
    </Stack>
  </Stack>
);
